module.exports = __webpack_public_path__ + "img/li.850eef34.svg";